/**
 * Chuyển payload của FilterBar (Dashboard Suite) sang shape mà hai endpoint CŨ của `DashboardAppService`
 * nhận. Tách ra module thuần để test được (bẫy 11) và để chỗ duy nhất biết về sự lệch shape này.
 *
 * Hai endpoint đó dùng `DashboardFilter` (dự án là MỘT `ProjectId`, phân trang `SkipCount`/`MaxResultCount`),
 * còn Dashboard Suite gửi `ProjectIds` là DANH SÁCH. Feature-0199 task 12 chỉ **mở rộng** hai endpoint cũ
 * (thêm 3 chiều cắt) và giữ nguyên shape để dashboard cũ không vỡ — nên việc quy đổi nằm ở FE.
 */

export interface ILegacyDashboardPayload {
  FromDate?: unknown
  ToDate?: unknown
  TowerIds?: number[]
  ZoneIds?: number[]
  PropertyTypeIds?: number[]
  ProjectId?: number
  SkipCount?: number
  MaxResultCount?: number
}

/**
 * `ProjectId` chỉ được gửi khi người dùng chọn ĐÚNG MỘT dự án — endpoint cũ không diễn tả được nhiều dự
 * án. Chọn nhiều dự án thì bỏ hẳn param (widget tự lọc lại theo danh sách đã chọn), vì gửi một dự án bất kỳ
 * trong số đó sẽ ra con số của một dự án mà nhãn lại nói "đang lọc N dự án".
 */
export const toLegacyDashboardPayload = (
  payload?: Record<string, unknown>,
  options?: { maxResultCount?: number }
): ILegacyDashboardPayload => {
  const source = payload ?? {}
  const projectIds = (source.ProjectIds as number[] | undefined) ?? []

  const result: ILegacyDashboardPayload = {
    FromDate: source.FromDate,
    ToDate: source.ToDate,
    TowerIds: (source.TowerIds as number[] | undefined) ?? [],
    ZoneIds: (source.ZoneIds as number[] | undefined) ?? [],
    PropertyTypeIds: (source.PropertyTypeIds as number[] | undefined) ?? [],
  }

  if (projectIds.length === 1) result.ProjectId = projectIds[0]

  if (options?.maxResultCount) {
    result.SkipCount = 0
    result.MaxResultCount = options.maxResultCount
  }

  return result
}

/**
 * Lọc lại danh sách theo dự án đã chọn — dùng khi không đẩy được `ProjectId` xuống endpoint cũ. Không chọn
 * dự án nào ⇒ giữ nguyên (không lọc), đúng quy ước của cả đợt.
 */
export const filterRowsBySelectedProjects = <T extends { projectId?: number | null }>(
  rows: T[],
  payload?: Record<string, unknown>
): T[] => {
  const projectIds = (payload?.ProjectIds as number[] | undefined) ?? []
  if (projectIds.length === 0) return rows

  return rows.filter(
    (row) => row.projectId != null && projectIds.includes(row.projectId)
  )
}
